<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Conditions Générales d'Utilisation</div>
    </v-ons-toolbar>

    <div class="content">

      <section v-if="cguHtml" style="padding: 15px" v-html="cguHtml"></section>
      <section v-else style="text-align: center; margin-top: 20px;">
        <v-ons-progress-circular :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </section>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

export default {
  mixins: [mixinsCommons],
  props: ['pageStack'],
  data() {
    return {
      cguHtml: ''
    };
  },
  methods: {
  },
  created() {
    var fetchInit = this.$getFetchInit('GET');
    fetch(this.$apiDomain + '/cgu', fetchInit)
      .then(this.handleResponse)
      .then(response => {
        this.cguHtml = response.html;
      })
      .catch(error => {
        this.handleError(error, 'du chargement des conditions générales');
      });
  }
};
</script>
